// src/components/BoardOfEd/components/Program3000.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3000_CONFIG = {
  fullName: "AGRISCIENCE & TECHNOLOGY",
  docId: "3000",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesSupervision",
      label: "Salaries – Supervision",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Supervision" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarialPT",
      label: "Salaries – Secretarial, P-T",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Secretarial, P-T" },
        { block: "Salaries", key: "Secretarial, P-t" }, // safety
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesStudentHelpPT",
      label: "Salaries – Student Help, P-T",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Student Help, P-T" }],
      group: "salaries",
      defaultVisible: false,
    },

    // Field Trips (keep with salaries like other programs)
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Supplies / Materials", key: "Field Trips" }, // future-proof
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "purchasedTransportMentor",
      label: "Transportation / Mentor Program",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Transportation/Mentor Program" },
        { block: "Purchased Services", key: "TRANSPORTATION/MENTOR PROGRAM" },
      ],
      group: "purchased Services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "printingPublications",
      label: "Printing / Publications",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Printing/Publications" },
        { block: "Supplies / Materials", key: "Printing / Publications" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "studentSupervision",
      label: "Student Supervision",
      valueType: "currency",
      sources: [{ block: "Other", key: "Student Supervision" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "teachersTravelMeetings",
      label: "Teachers Travel / Meetings",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Teachers Travel/Meetings" },
        { block: "Other", key: "Teachers Travel / Meetings" },
      ],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
        { block: "Other", key: "Dues and Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipmentNewRplcSystemwide",
      label: "New/RPLC Equipment (Systemwide)",
      valueType: "currency",
      sources: [
        {
          block: "Equipment",
          key: "New/RPLC Equipment (Systemwide)",
        },
      ],
      group: "equipment",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsTeachers",

        // Salaries
        "salariesSupervision",
        "salariesTeachers",
        "salariesSecretarialPT",
        "salariesStudentHelpPT",
        "fieldTrips",

        // Purchased Services
        "purchasedTransportMentor",

        // Supplies / Materials
        "instructionalMaterials",
        "printingPublications",
        "technologySoftware",

        // Other
        "studentSupervision",
        "teachersTravelMeetings",
        "duesFees",

        // Equipment
        "equipmentNewRplcSystemwide",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesSupervision: { minWidth: "110px" },
        salariesTeachers: { minWidth: "100px" },
        salariesSecretarialPT: { minWidth: "152px" },
        salariesStudentHelpPT: { minWidth: "140px" },
        fieldTrips: { minWidth: "90px" },

        // Purchased Services
        purchasedTransportMentor: { minWidth: "180px" },

        // Supplies / Materials
        instructionalMaterials: { minWidth: "120px" },
        printingPublications: { minWidth: "120px" },
        technologySoftware: { minWidth: "120px" },

        // Other
        studentSupervision: { minWidth: "120px" },
        teachersTravelMeetings: { minWidth: "130px" },
        duesFees: { minWidth: "100px" },

        // Equipment
        equipmentNewRplcSystemwide: { minWidth: "200px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsTeachers",

        // Salaries
        "salariesSupervision",
        "salariesTeachers",
        "salariesSecretarialPT",
        "salariesStudentHelpPT",
        "fieldTrips",

        // Purchased Services
        "purchasedTransportMentor",

        // Supplies / Materials
        "instructionalMaterials",
        "printingPublications",
        "technologySoftware",

        // Other
        "studentSupervision",
        "teachersTravelMeetings",
        "duesFees",

        // Equipment
        "equipmentNewRplcSystemwide",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesSupervision: { minWidth: "110px" },
        salariesTeachers: { minWidth: "100px" },
        salariesSecretarialPT: { minWidth: "152px" },
        salariesStudentHelpPT: { minWidth: "140px" },
        fieldTrips: { minWidth: "90px" },

        // Purchased Services
        purchasedTransportMentor: { minWidth: "180px" },

        // Supplies / Materials
        instructionalMaterials: { minWidth: "120px" },
        printingPublications: { minWidth: "120px" },
        technologySoftware: { minWidth: "120px" },

        // Other
        studentSupervision: { minWidth: "120px" },
        teachersTravelMeetings: { minWidth: "130px" },
        duesFees: { minWidth: "100px" },

        // Equipment
        equipmentNewRplcSystemwide: { minWidth: "200px" },
      },
    },
  ],
};

export function Program3000(props) {
  return (
    <ProgramBudget
      programId="3000"
      config={PROGRAM_3000_CONFIG}
      {...props}
    />
  );
}
